import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'tellent-assistant-tool-call-part',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <span class="pill" [class.error]="status() === 'error'">
      @if (status() === 'running') {
        <span class="spinner" aria-hidden="true"></span>
        Looking into {{ name() }}…
      } @else if (status() === 'done') {
        Worked for {{ formatDuration(durationMs()) }}
      } @else {
        <span role="img" aria-label="Error">!</span> Tool failed
      }
    </span>
  `,
  styleUrls: ['./tool-call-part.component.less'],
})
export class TellentAssistantToolCallPartComponent {
  public readonly name = input.required<string>();
  public readonly status = input.required<'running' | 'done' | 'error'>();
  public readonly durationMs = input<number | null>(null);

  protected formatDuration(ms: number | null | undefined): string {
    if (ms == null) return '0s';
    const s = Math.max(1, Math.round(ms / 1000));
    return `${s}s`;
  }
}
